import React from 'react';
import { Form } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

import { Heading } from '../../components/atoms/Heading';
import { ProgressBar } from '../../components/molecules/ProgressBar';
// import { Image } from '../../components/atoms/Image';
import { MainView } from '../../templates/MainView';

import { StickyButtons } from '../../components/molecules/StickyButtons';
import { ButtonGroup } from '../../components/molecules/ButtonGroup';
import { Button } from '../../components/atoms/Button';

import { Text } from '../../components/atoms/Text';

import { Field } from '../../components/molecules/Field';
import required from '../../components/validation/required';
import { InfoCard } from '../../components/molecules/InfoCard';


function Question({title, questions, next, showHeading}) {
    const navigate = useNavigate();

    const options = [
        {
            title: 'Yes',
            value: 'yes',
        },
        {
            title: 'No',
            value: 'no',
        },
    ];

    const [messages, setMessages] = React.useState({});


    return (
        <MainView>
            <Form
                onSubmit={(values) => {
                    // get previous data from local storage variable
                    const data = JSON.parse(localStorage.getItem('data')) || {};

                    // add new data to local storage variable
                    localStorage.setItem('data', JSON.stringify({
                        ...data,
                        ...values,
                    }));

                    navigate(next);
                }}
                >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="h-auto w-full">
                            <div className="flex flex-col gap-3">
                                <div className="flex flex-col gap-4 px-6 py-3 md:py-5 md:px-12">
                                    { showHeading && <Heading h1>Check your eligibility</Heading> }
                                    { showHeading && <Text>To check you are eligible for an NHS Health check please fill out this form. If you do not know the answers to these questions, contact your GP prior to booking. If you do not meet the criteria, you won't be able to make an appointment.</Text>}
                                    <div className='input-container'>
                                        <div className="input-top">
                                            <em style={{
                                                fontSize: '2rem',
                                                marginTop: '1rem'
                                            }}>*</em> <span>&nbsp;Required field</span>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <div class="help-icon">
                                                    <button type="button">
                                                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 41C32.4934 41 41 32.4934 41 22C41 11.5066 32.4934 3 22 3C11.5066 3 3 11.5066 3 22C3 32.4934 11.5066 41 22 41ZM22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z" fill="currentColor"></path><path d="M21.9402 7C20.2287 7 19 8.22875 19 9.89633C19 11.6078 20.2287 12.8365 21.9402 12.8365C23.6078 12.8365 24.8365 11.6078 24.8365 9.89633C24.8365 8.22875 23.6078 7 21.9402 7ZM24.3099 16.9962C24.3099 16.4439 23.8622 15.9962 23.3099 15.9962H20.2633C19.711 15.9962 19.2633 16.4439 19.2633 16.9962V34.7C19.2633 35.2523 19.711 35.7 20.2633 35.7H23.3099C23.8622 35.7 24.3099 35.2523 24.3099 34.7V16.9962Z" fill="currentColor"></path></svg>
                                                    </button>
                                                </div>
                                                <span>&nbsp;Click here for further information</span>

                                        </div>
                                    </div>
                                    

                                    <Heading h2>{title}</Heading>

                                    {questions.map((question, index) => (<>
                                        { messages[question.fieldKey] && 
                                        <InfoCard
                                            setInnerHtml
                                            variant="primary-dark"
                                            text="We are sorry – you are not currently eligible for an NHS Health Check. Please <a href='https://www.livewelldorset.co.uk'>click here</a> for more information on looking after your health"
                                            icon="form-error"
                                        />
                                        }
                                    <Field
                                        name={question.fieldKey}
                                        label={question.question}
                                        input="radio"
                                        isRequired
                                        
                                        help={question.hint}
                                        inputOptions={{
                                            options
                                        }}
                                        inputOnChange={(value) => {
                                            const requiredAnswer = question.answer === 'yes' ? 'yes' : 'no';
                                            if(value === requiredAnswer) {
                                                // clear any set messages
                                                setMessages({
                                                    ...messages,
                                                    [question.fieldKey]: ''
                                                });

                                            } else {
                                                // add message to object with question field key as key
                                                setMessages({
                                                    ...messages,
                                                    [question.fieldKey]: 'You are not eligible for an NHS Health Check'
                                                });
                                                console.log('no');
                                            }
                                        }}
                                    />
                                    </>))}

                                </div>
                            </div>
                            <div className="px-6 pb-12 pt-6">
                                <StickyButtons>
                                    <ButtonGroup
                                        mode="pair"
                                        alwaysRow
                                        buttons={[
                                            <Button
                                                label="Back"
                                                mode="secondary"
                                                onClick={() => navigate(-1)}
                                                type="button"
                                                // isDisabled={isFirstStep}
                                            />,
                                            <Button
                                                label="Continue"
                                                mode="primary"
                                                isSubmit
                                                isDisabled={!values[questions[(questions.length - 1)].fieldKey]}
                                            />,
                                        ]}
                                    />
                                </StickyButtons>
                            </div>
                        </div>
                    </form>
                )}
            </Form>
        </MainView>
    );
}

export default Question;
